// LanguageContext.js
import React, { createContext, useState, useContext } from "react";

// إنشاء الـ Context
const LanguageContext = createContext();

// مكون لتوفير اللغة لكافة الكمبوننتات في التطبيق
export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("ar"); // اللغة الافتراضية هي العربية

  // دالة لتبديل اللغة
  const toggleLanguage = () => {
    setLanguage((prevLanguage) => (prevLanguage === "en" ? "ar" : "en"));
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

// دالة للوصول للغة في أي مكان في التطبيق
export const useLanguage = () => useContext(LanguageContext);